import Styled from 'styled-components'
import STYLE_CONSTANTS from '~/style/constants'
import PropTypes from 'prop-types'

const Divider = Styled.div`
  width: ${props => props.width || '100%'};
  height: 1px;
  background-color: ${props => props.theme.colors.ui.inputBorder};
  ${props => (props.top ? `margin-top: ${props.top}px;` : null)}
  ${props => (props.bottom ? `margin-bottom: ${props.bottom}px;` : null)}
`

Divider.defaultProps = {
  top: null,
  bottom: null
}

Divider.propTypes = {
  top: PropTypes.number,
  bottom: PropTypes.number
}

export default Divider
